import { render } from "./MultiSigEditor.vue?vue&type=template&id=68426a10"
import script from "./MultiSigEditor.vue?vue&type=script&lang=js"
export * from "./MultiSigEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__